const RightArrowIcon = () => {
  return (
    <svg
      width="9"
      height="15"
      viewBox="0 0 9 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginLeft: '8px' }}
    >
      <path
        d="M0.699871 13.6808C0.699871 13.8982 0.784732 14.1188 0.950214 14.2837C1.28149 14.6138 1.82927 14.6138 2.16055 14.2837L8.35952 8.10657C8.51952 7.94714 8.60986 7.72221 8.60986 7.50369C8.60986 7.28723 8.5308 7.0715 8.35952 6.90082L2.1685 0.732167C1.8421 0.386589 1.28138 0.382154 0.950108 0.712264C0.618832 1.04237 0.618832 1.58822 0.950108 1.91833L0.950315 1.91853L6.5553 7.49266L0.95005 13.0781C0.784259 13.2433 0.699707 13.4639 0.699707 13.681L0.699871 13.6808Z"
        fill="white"
      />
    </svg>
  );
};
export default RightArrowIcon;
